<template>
  <banner />
  <app-simple-search-competition
    :color="color1"
    :colorBg="color9"
    :colorBtn="color4"
    searchHolder="Buscar competición"
    link="competition-page"
    link-all="home-resultados-busqueda"
  />
  <the-home-services />
  <the-llamada-accion-secundaria />
  <the-torneos-populares-mes />
  <the-top-embajadores />
  <lista-novedades-ds />
  <footer-home />
</template>

<script>
import { defineAsyncComponent } from 'vue'
//
import { mapActions, mapGetters } from 'vuex'
//
import { color1, color4, color9 } from '@/scss/_config.scss'

import Banner from '@/components/home/Banner.vue'
import AppSimpleSearchCompetition from '@/components/apps/AppSimpleSearchCompetition.vue'
import TheHomeServices from '@/components/home/TheHomeServices.vue'
import TheLlamadaAccionSecundaria from '@/components/home/TheLlamadaAccionSecundaria.vue'
import TheTorneosPopularesMes from '@/components/torneo/TheTorneosPopularesMes.vue'
import TheTopEmbajadores from '@/components/home/TheTopEmbajadores.vue'

export default {
  name: 'Home',
  components: {
    Banner,
    AppSimpleSearchCompetition,
    TheHomeServices,
    TheLlamadaAccionSecundaria,
    TheTorneosPopularesMes,
    TheTopEmbajadores,
    ListaNovedadesDs: defineAsyncComponent(() => import('@/components/equipods/ListaNovedadesDs.vue')),
    FooterHome: defineAsyncComponent(() => import('@/components/includes/FooterHome.vue')),
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn'
    })
  },
  data() {
    return {
      color1: color1,
      color4: color4,
      color9: color9,
    }
  },
  methods: {
    ...mapActions({
      cargarHome: 'cargarHome',
    })
  },
  created() {
    if (this.isLoggedIn) {
      this.$router.push({name: 'home-user'})
    }
  },
}
</script>
